/**
 * System messages to customers (D78): limits and the link check shared by the API (enforcement)
 * and the apps (form hints, showing where a link goes).
 */
export const SYSTEM_MESSAGE_LEVELS = ["INFO", "WARNING", "CRITICAL"];
export const SYSTEM_MESSAGE_LIMITS = {
    title: 80,
    body: 500,
    linkLabel: 40,
    linkUrl: 500,
    /** Recipients of one "chosen customers" message. */
    recipients: 500,
};
/**
 * Links may go to any https site (owner's choice, D78), with safeguards: https only, no user name
 * or password inside the URL, a real host name. Returns the normalised URL and the host to show
 * on the button ("Opens example.com").
 */
export function checkMessageLink(raw) {
    const value = raw.trim();
    if (value.length > SYSTEM_MESSAGE_LIMITS.linkUrl)
        return { ok: false, reason: "The link is too long" };
    let url;
    try {
        url = new URL(value);
    }
    catch {
        return { ok: false, reason: "That isn't a valid web address" };
    }
    if (url.protocol !== "https:")
        return { ok: false, reason: "Links must start with https://" };
    if (url.username || url.password)
        return { ok: false, reason: "Links can't contain a user name or password" };
    if (!url.hostname.includes(".") || url.hostname.endsWith(".")) {
        return { ok: false, reason: "Use a full web address like https://example.com" };
    }
    return { ok: true, url: url.href, host: url.hostname };
}
//# sourceMappingURL=system-messages.js.map